import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import MetricsDashboard from "./pages/MetricsDashboard";
import StatusPage from "./pages/StatusPage";
import LandingPage from "./pages/LandingPage";
import VetCanStudio from "./pages/VetCanStudio";
import VetCanStudioPreview from "./pages/VetCanStudioPreview";
import VetcanLanding from "./pages/VetcanLanding";
import WhiteLabelLanding from "./pages/WhiteLabelLanding";
import WhiteLabelChatPage from "./pages/WhiteLabelChatPage";
import {
  getWhiteLabelTenantConfig,
  type WhiteLabelTenantConfig,
} from "./lib/tenantConfig";
import { resolveTenantKeyRuntime } from "./lib/runtimeTenant";

export function isMarijuanaExpressHost(hostname: string): boolean {
  const tenantKey = resolveTenantKeyRuntime({
    hostname,
    search: "",
    isProduction: true,
  });
  return Boolean(getWhiteLabelTenantConfig(tenantKey));
}

export default function App({ hostnameOverride }: { hostnameOverride?: string }) {
  const tenantKey = resolveTenantKeyRuntime({
    hostname:
      hostnameOverride ||
      (typeof window !== "undefined" ? window.location.hostname : ""),
    search: typeof window !== "undefined" ? window.location.search : "",
  });
  const tenant: WhiteLabelTenantConfig | null = getWhiteLabelTenantConfig(tenantKey);
  const whiteLabelMode = Boolean(tenant);

  return (
    <BrowserRouter>
      {whiteLabelMode ? (
        <Routes>
          <Route
            path="/"
            element={<WhiteLabelLanding tenant={tenant!} tenantKey={tenantKey} />}
          />
          <Route
            path="/chat"
            element={<WhiteLabelChatPage tenant={tenant!} tenantKey={tenantKey} />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<MetricsDashboard />} />
          <Route path="/metrics" element={<MetricsDashboard />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/studio" element={<VetCanStudio />} />
          <Route path="/studio/preview" element={<VetCanStudioPreview />} />
          <Route path="/vetcan" element={<VetcanLanding />} />
          <Route path="/status" element={<StatusPage />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}
